import React from "react";
import { ServiceTypeEnum } from "../../../../../../common-deprecated/types/SettingsType";
import useService from "../../../hooks/services/useService";
import * as ServiceStyles from "./styles/SharedService";

const BannerService = (): JSX.Element | null => {
    const data = useService(ServiceTypeEnum.Banner);

    if (!data) return null;
    const { title, description, bannerLinkImage, bannerLinkLabel, bannerLinkUrl } = data;

    return (
        <ServiceStyles.ServiceWrapper>
            {bannerLinkImage && (
                <ServiceStyles.Banner>
                    <ServiceStyles.Image src={`${bannerLinkImage}`} height={170} />
                </ServiceStyles.Banner>
            )}

            {title && <ServiceStyles.Title>{title}</ServiceStyles.Title>}

            {description && (
                <ServiceStyles.Description>
                    <span dangerouslySetInnerHTML={{ __html: description }} />
                </ServiceStyles.Description>
            )}

            {bannerLinkLabel && bannerLinkUrl && (
                <ServiceStyles.OutlineLink as="a" href={bannerLinkUrl}>
                    {bannerLinkLabel}
                </ServiceStyles.OutlineLink>
            )}
        </ServiceStyles.ServiceWrapper>
    );
};

export default BannerService;
